<template>
    <el-dialog
            title="提示"
            :visible.sync="newIsWarnInfo"
            :append-to-body="true"
            width="30%"
            :before-close="()=>newIsWarnInfo = false">
        <span>{{wanInfo[type]}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="newIsWarnInfo = false">取 消</el-button>
            <el-button :loading="newLoading" type="primary" @click="submit">确 定</el-button>
          </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "warnInfo",
        props: {
            isWarnInfo: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            type: String
        },
        watch: {
            isWarnInfo(vl){this.newIsWarnInfo = vl},
            newIsWarnInfo(vl){this.$emit('update:isWarnInfo',vl)},
            loading(vl){this.newLoading = vl},
            newLoading(vl){this.$emit('update:loading',vl)},
        },
        data(){
            return {
                wanInfo: {
                    template: '添加模版到课件, 是否继续?',
                    scenes: '此操作将覆盖当前所有课程场景, 是否继续?'
                },
                newIsWarnInfo: this.isWarnInfo,
                newLoading: this.loading
            }
        },
        methods: {
            submit(){
                if(this.newLoading || this.$utils.isFastExecute(500)){
                    return false
                }
                this.newLoading = true
                this.$emit('success')
            },
        }
    }
</script>

<style scoped>

</style>
